import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root', })
export class footerService {

    constructor(
        private http: HttpClient
    ) {}

    getAppVersion() {
        return this.http.get<any>(`${environment.BACKEND}config/version`);
    }
}
